export enum EFsAction {
  DELETE,
  RENAME,
  TAGS,
  DOWNLOAD,
}
